import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"width":"100vw","height":"100vh"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { id: "contet" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "siteNotice" }, null, -1 /* HOISTED */)
const _hoisted_5 = { id: "bodyContent" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "สถานะประตู", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoWindow = _resolveComponent("InfoWindow")
  const _component_Marker = _resolveComponent("Marker")
  const _component_GoogleMap = _resolveComponent("GoogleMap")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.apiKey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_GoogleMap, {
            "api-key": $data.apiKey,
            style: {"width":"100%","height":"100vh"},
            center: $data.center,
            zoom: $data.zoom
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.waterGates, (d) => {
                return (_openBlock(), _createBlock(_component_Marker, {
                  onClick: ()=>d.isOpenInfo =false,
                  options: { icon : {url : $options.getIcon(d), scaledSize:{width:40,height:40}} ,position: { lat: d.lat, lng: d.lng } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InfoWindow, {
                      modelValue: d.isOpenInfo,
                      "onUpdate:modelValue": $event => ((d.isOpenInfo) = $event)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(d.name) + " ", 1 /* TEXT */),
                            _hoisted_6,
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(d.status) + " ", 1 /* TEXT */),
                            _hoisted_8,
                            _createElementVNode("img", {
                              src: d.image,
                              style: {"width":"10vw","height":"auto"}
                            }, null, 8 /* PROPS */, _hoisted_9),
                            _hoisted_10
                          ])
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "options"]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["api-key", "center", "zoom"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}